export default __webpack_public_path__ + "static/media/no-avatar.d821428d.jpg";